module.exports = __webpack_public_path__ + "09c898ebd7570030da05c6beb37596af.png";